import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useBoundStore } from "@/app/store";

/**
 * Internal component that captures the Lexical editor from the composer context
 * and stores it in global state so it can be accessed from anywhere (including navbar).
 */
export function EditorContextProvider({ children }: { children: React.ReactNode }) {
  const [editor] = useLexicalComposerContext();
  const setEditorInstance = useBoundStore((state) => state.setEditorInstance);

  useEffect(() => {
    setEditorInstance(editor);
    return () => {
      setEditorInstance(null);
    };
  }, [editor, setEditorInstance]);

  return children;
}
